import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import {ContainerEngine} from "../../../utilities/ContainerEngine";
import {getCssVariable} from "../../../utilities/Helper";
import {onWindowResize} from "../../../utilities/Hooks";


function getContainerOffsetX() {
    try {
        return ContainerEngine.find('xl').offsetX;
    } catch (e){
        return 0;
    }
}
function computeContainerOffsetX() {
    return getContainerOffsetX() + parseInt(getCssVariable('--container-padding'));
}

function updateHeadingElementOffsetX(element) {
    element.style.marginLeft = `${computeContainerOffsetX()}px`;
}

function getNewSwiperInstance() {
    return new Swiper('#carouselProjects', {
        modules: [Navigation],
        speed: 400,
        freeMode: {
            enabled: false,
            sticky: false,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 'auto',
        slidesOffsetBefore: computeContainerOffsetX,
        spaceBetween: 20,
    });
}

export default function setupCarouselProjects() {
    if (document.querySelector('.section-projects') === null) return;
    const swiper = getNewSwiperInstance();
    const projectsHeadingElement = document.querySelector('.section-projects__header');
    updateHeadingElementOffsetX(projectsHeadingElement);

    onWindowResize(() => {
        swiper.params.slidesOffsetBefore = computeContainerOffsetX();
        updateHeadingElementOffsetX(projectsHeadingElement);
    })
}
